module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/may-dd04913631309e3a12927976e6eb2707.png";